import React from 'react';
import * as constantClass from '../fileWithConstants';
import { createPagedGridController } from '../../hooks/pagedGridClassAdapter';
import * as cursadasService from '../../services/cursadas/cursadasService';
import { classifyCursadasError } from '../../services/cursadas/cursadasDto';
import { LookupModal, LookupSelectButton, LookupActionHeader } from '../common/LookupModal';
import { createLookupSearchHandlers } from '../common/lookupGridSearch';

function formatPeriodoCursada(periodoCursadaDescripcion) {
  if (periodoCursadaDescripcion === '1') {
    return 'Primer Cuatrimestre';
  }
  if (periodoCursadaDescripcion === '2') {
    return 'Segundo Cuatrimestre';
  }
  return 'Anual';
}

export class LookupCursadasAlumnos extends React.Component {
  constructor(props) {
    super(props);
    this.searchInputRef = React.createRef();
    this.state = {
      show: true,
      loading: true,
      searchInput: '',
      perPage: 5,
      paginationData: [],
      pageCount: 1,
      forcePage: 0,
      showErrorMessage: false,
      errorMessage: '',
      carreraCod: props.carreraCod,
      alumnoCarreraCod: props.alumnoCarreraCod,
    };
    this.grid = createPagedGridController({
      fetchPage: (query) => cursadasService.listCursadasActivasForAlumnoPaged(
        this.state.carreraCod,
        this.state.alumnoCarreraCod,
        query
      ),
      defaultPageSize: 5,
      onChange: (gridState) => this.applyGridState(gridState),
    });
    const searchHandlers = createLookupSearchHandlers(
      this,
      this.grid,
      (error) => this.handleCursadasError(error)
    );
    this.handleSearchInputChange = searchHandlers.handleSearchInputChange;
    this.handleSearchSubmit = searchHandlers.handleSearchSubmit;
  }

  handleModal() {
    this.setState({ show: !this.state.show });
    this.props.hideLookup();
  }

  async componentDidMount() {
    const canAccess = await constantClass.canAccess('InscribirCursada');
    if (canAccess) {
      this.populateData(this.state.carreraCod);
    }
  }

  applyGridState(gridState) {
    this.setState({
      paginationData: gridState.items,
      pageCount: gridState.pageCount,
      searchInput: gridState.search,
      perPage: gridState.pageSize,
      loading: gridState.loading,
      forcePage: gridState.forcePage,
      showErrorMessage: Boolean(gridState.error),
      errorMessage: gridState.error?.message ?? '',
    });
  }

  handlePageClick = (e) => {
    this.grid.handlePageClick(e).catch((error) => this.handleCursadasError(error));
  };

  handleItemSelect = (e) => {
    this.props.selectItem(e);
    this.setState({ show: false });
  };

  renderTable(cursadas) {
    return (
      <table className="md-lookup__table md-lookup__table--cursadas-alumno" aria-label="Seleccionar la Cursada">
        <thead>
          <tr>
            <th scope="col">Materia</th>
            <th scope="col" className="md-lookup__col-periodo-cursada">Período de Cursada</th>
            <th scope="col" className="md-lookup__col-anio-academico">Año Académico</th>
            <LookupActionHeader />
          </tr>
        </thead>
        <tbody>
          {cursadas.map((cursada) => (
            <tr key={cursada.cursadaCod}>
              <td>{cursada.materiaNombre}</td>
              <td className="md-lookup__col-periodo-cursada">{formatPeriodoCursada(cursada.periodoCursadaDescripcion)}</td>
              <td className="md-lookup__col-anio-academico">{cursada.anioAcademicoDescripcion}</td>
              <LookupSelectButton
                onClick={() => this.handleItemSelect(
                  `${cursada.cursadaCod}%${cursada.materiaNombre}%${cursada.periodoCursadaDescripcion}%${cursada.anioAcademicoDescripcion}%${cursada.materiaCarreraCod}`
                )}
              />
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  render() {
    return (
      <LookupModal
        show={this.state.show}
        onHide={() => this.handleModal()}
        title="Seleccionar la Cursada"
        searchInputRef={this.searchInputRef}
        searchInput={this.state.searchInput}
        searchPlaceholder="Ingrese la materia"
        onSearchInputChange={this.handleSearchInputChange}
        onSearchSubmit={this.handleSearchSubmit}
        loading={this.state.loading}
        errorMessage={this.state.showErrorMessage ? this.state.errorMessage : ''}
        pageCount={this.state.pageCount}
        forcePage={this.state.forcePage}
        onPageChange={this.handlePageClick}
      >
        {this.renderTable(this.state.paginationData)}
      </LookupModal>
    );
  }

  handleCursadasError(error) {
    const outcome = classifyCursadasError(error);
    if (outcome.type === 'timeout') {
      constantClass.RedirectToLogin();
      return;
    }
    this.setState({
      showErrorMessage: true,
      errorMessage: outcome.message,
      loading: false,
    });
  }

  async populateData(carreraCod) {
    try {
      if (carreraCod != null) {
        this.setState({ carreraCod });
      }
      await this.grid.load();
    } catch (error) {
      this.handleCursadasError(error);
    }
  }
}
